import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { ReportsList } from '../models/reports-list.model';
import { ApiService } from './api.service';
import { SessionStorageService } from './session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {
  public companyContextSubscription: Subscription;
  public companyContext: string;

  constructor(private apiService: ApiService, private sessionStorageService: SessionStorageService) {
    this.companyContextSubscription = sessionStorageService.companyChange.subscribe( company => {
      this.companyContext = company;
      console.log("Company context: ", this.companyContext)
    })
  }

  public getReports(cursor?: string): Promise<ReportsList> {
      if (!this.companyContext) return;      

      let data = {
        "accountType": "CMC",
        "documentType": "listcmcbpp",
        "cursor": cursor
      }

      if(this.companyContext === "Pingora" || this.companyContext === "Lakeview") {
        data['companyName'] = this.companyContext
      } else if (this.companyContext === "Arvest Central Mortgage Company" || "National General") {
        data['companyName'] = "NatGen";
      }

      return this.apiService.post(`/reports/`, data);
    // }
  }

  public getReportById(id): Promise<any> {
    if (id) {

      const data = {
        documentId: id
      }
      return this.apiService.post(`/reports/get`, data);

    }
  }
}
